/**
 * Control the behaviour of the site header. This includes 
 * the hamburger menu and dropdown menus. It would also be where 
 * to handle a search bar should one exist.
 */
import { Layout, vh } from '../inc/global'


const { header, body } = Layout; // Semi-colon here forces Layout to not be a function...


( () => {
    const mobileMenuTrigger  = document.querySelector( '#mobile-menu-trigger' ),
          mobileMenu         = document.querySelector( '.mobile-menu' ),
          mobileMenuSubMenus = mobileMenu?.querySelectorAll( 'li.level-0-item.has-sub-menu' ) || [],
          menu               = document.querySelector( 'header.site-header nav' ),
          menuSubMenus       = menu?.querySelectorAll( 'li.has-sub-menu' ) || [],
          headerWrapper      = header.parentElement,
          overlay            = document.getElementById( 'overlay' )


    // Header Height Variable dynamically added
    function updateHeight() {
        document.documentElement.style.setProperty( '--header-height', header.offsetHeight + 'px' )
    }

    window.addEventListener( 'load', updateHeight )
    window.addEventListener( 'resize', updateHeight )

    /**
     * Sticky peek-a-boo header
     */
    let previousScroll = 0
    function displayStickyHeader() {
        const scrollPos = window.pageYOffset || document.documentElement.scrollTop
        const threshold = vh() / 4

        /** Sticky header can only be available after the threshold */
        if ( scrollPos >= threshold ) {
            header.classList.add( 'pre-set-sticky' )

            setTimeout( () => {
                header.classList.add( 'set-sticky' )
            }, 50 )

            /** Catch scroll up */
            if ( scrollPos < previousScroll ) {
                
                /** Match scroll up against a threshold that must be reached */
                if ( previousScroll > scrollPos + 60 ) {
                    header.classList.add( 'is-visible' )
                    body.classList.add( 'header-state-active' )
                    updateHeight();
                } else {
                    return
                }

            } else {
                header.classList.remove( 'is-visible' )
                body.classList.remove( 'header-state-active' )
            }

        } else if ( scrollPos > previousScroll || scrollPos <= 0 ) {
            header.classList.remove( 'pre-set-sticky', 'set-sticky', 'is-visible' )
            body.classList.remove( 'header-state-active' )
            updateHeight();
        }

        previousScroll = scrollPos
    }
    window.addEventListener( 'scroll', displayStickyHeader, { passive: true } )


    /**
     * Mobile menu
     */
     let isOpen = false
     mobileMenu.addEventListener( 'click', e => e.stopPropagation() )
 
     const toggleMobileMenu = e => {
        e.stopPropagation()

        if ( isOpen ) {
        mobileMenu.setAttribute( 'aria-hidden', true )
        headerWrapper.classList.remove( 'mobile-menu-active' )
        body.classList.remove( 'no-scroll', 'overlay-active', 'menu-search--active' )
        mobileMenuTrigger.classList.remove( 'burger-active' )


        mobileMenu.classList.remove( 'sub-menu-active' )
        mobileMenu.querySelectorAll( 'li.has-sub-menu.is-visible' )?.forEach( el => {
            el.classList.remove( 'is-visible' )
        })

        } else {
        mobileMenu.setAttribute( 'aria-hidden', false )
        headerWrapper.classList.add( 'mobile-menu-active' )
        body.classList.add( 'no-scroll', 'overlay-active' )
        mobileMenuTrigger.classList.add( 'burger-active' )
        }

        isOpen = !isOpen
     }
     mobileMenuTrigger.addEventListener( 'click', toggleMobileMenu )
     overlay.addEventListener( 'click', toggleMobileMenu )

    /**
     * Sub menu event handling
     */
    menu?.classList.add( menuSubMenus.length <= 0 ? 'has-no-sub-menus' : 'has-sub-menus' )
    mobileMenu.querySelector( 'nav' )?.classList.add( mobileMenuSubMenus.length <= 0 ? 'has-no-sub-menus' : 'has-sub-menus' )
    const displayClass = 'is-visible'

    // Primary sub-menus
    menuSubMenus.forEach( ({ children, classList }) => {
        const link = children[0],
            subMenuEl = children[1]

        let removeOpen

        const isMegaMenu = classList.contains( 'menu-item-29' ) || classList.contains( 'menu-item-20091' )

        link.addEventListener( 'mouseover', e => {
            e.preventDefault()

            clearTimeout( removeOpen )

            if ( classList.contains( displayClass ) !== true ) {
                classList.add( displayClass )

                if ( isMegaMenu ) {
                    body.classList.add( 'overlay-active' )
                    document.querySelector( '.nav-left .menu-item-29.level-0-item > .sub-menu-wrapper' ).scrollTop = 0;
                }

            }
        })

        link.addEventListener( 'mouseleave', e => {
            removeOpen = setTimeout( () => {
                classList.remove( displayClass )

                if ( isMegaMenu ) {
                    // Check if another mega menu is hovered
                    const anotherMegaMenuOpen = Array.from( menuSubMenus ).some( menu => 
                        menu !== { children, classList } && 
                        menu.classList.contains( displayClass ) && 
                        (menu.classList.contains( 'menu-item-29' ) || menu.classList.contains( 'menu-item-20091' ))
                    )

                    if ( !anotherMegaMenuOpen ) {
                        body.classList.remove( 'overlay-active' )
                    }
                }

            }, 200 )
        })

        subMenuEl.addEventListener( 'mouseover', () => {
            clearTimeout( removeOpen )
        })

        subMenuEl.addEventListener( 'mouseleave', () => {
            removeOpen = setTimeout( () => {
                classList.remove( displayClass )

                if ( isMegaMenu ) {
                    const anotherMegaMenuOpen = Array.from( menuSubMenus ).some( menu => 
                        menu !== { children, classList } && 
                        menu.classList.contains( displayClass ) && 
                        (menu.classList.contains( 'menu-item-29' ) || menu.classList.contains( 'menu-item-20091' ))
                    )

                    if ( !anotherMegaMenuOpen ) {
                        body.classList.remove( 'overlay-active' )
                    }
                }
            }, 200 )
        })
    })

    // Mobile sub-menus
    mobileMenuSubMenus.forEach( subMenu => {
        const trigger = subMenu.querySelector( '.sub-menu-trigger' )
        const close = subMenu.querySelector( '.sub-menu-close' )

        trigger.addEventListener( 'click', e => {
            e.preventDefault()

            subMenu.classList.add( displayClass )
            mobileMenu.classList.add( 'sub-menu-active' )
        })

        close.addEventListener( 'click', e => {
            e.preventDefault()

            subMenu.classList.remove( displayClass )
            mobileMenu.classList.remove( 'sub-menu-active' )
        })

     })

      // Mega Menu Tabs
     document.addEventListener('DOMContentLoaded', function() {
        const tabButtons = document.querySelectorAll('.mega-menu-tabs__button');
        const tabPanels = document.querySelectorAll('.mega-menu-tabs__panel');

        tabButtons.forEach(button => {
            button.addEventListener('click', function() {
                const targetTab = this.getAttribute('data-tab');

                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabPanels.forEach(panel => panel.classList.remove('active'));

                this.classList.add('active');
                document.querySelector(`[data-panel="${targetTab}"]`).classList.add('active');
            });
        });
    });

})();
